import leadDetailsModal from './leadDetailsModal';

exports.addVenueModal = require('./addVenueModal');
exports.paymentHistoryModal = require('./paymentHistoryModal');
exports.assignGuestModal = require('./assignGuestModal');
exports.leadDetailsModal = leadDetailsModal;
